var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "pram",
          attrs: { model: _vm.pram, "label-width": "120px" },
          nativeOn: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: "服务名称",
                prop: "name",
                rules: [
                  {
                    required: true,
                    message: "请填写服务名称",
                    trigger: ["blur", "change"],
                  },
                ],
              },
            },
            [
              _c("el-input", {
                attrs: { placeholder: "服务名称" },
                model: {
                  value: _vm.pram.name,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.pram,
                      "name",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "pram.name",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: {
                label: "渠道服务编号",
                prop: "serviceType",
                rules: [
                  {
                    required: true,
                    message: "请填写渠道服务编号",
                    trigger: ["blur", "change"],
                  },
                ],
              },
            },
            [
              _c("el-input", {
                attrs: { placeholder: "渠道服务编号" },
                model: {
                  value: _vm.pram.serviceType,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.pram,
                      "serviceType",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "pram.serviceType",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: {
                label: "服务类型",
                prop: "serviceCategory",
                rules: [
                  {
                    required: true,
                    message: "请选择服务类型",
                    trigger: ["blur", "change"],
                  },
                ],
              },
            },
            [
              _c(
                "el-select",
                {
                  staticClass: "mr20",
                  staticStyle: { width: "100%" },
                  attrs: { placeholder: "请选择" },
                  model: {
                    value: _vm.pram.serviceCategory,
                    callback: function ($$v) {
                      _vm.$set(_vm.pram, "serviceCategory", $$v)
                    },
                    expression: "pram.serviceCategory",
                  },
                },
                _vm._l(_vm.isVirtualOptions, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "权益公里数", prop: "mileage" } },
            [
              _c("el-input-number", {
                attrs: { min: 0, max: 50, label: "权益公里数" },
                model: {
                  value: _vm.pram.mileage,
                  callback: function ($$v) {
                    _vm.$set(_vm.pram, "mileage", $$v)
                  },
                  expression: "pram.mileage",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "hasPermi",
                      rawName: "v-hasPermi",
                      value: [
                        "platform:admin:role:update",
                        "platform:admin:role:save",
                      ],
                      expression:
                        "['platform:admin:role:update', 'platform:admin:role:save']",
                    },
                  ],
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.handlerSubmit("pram")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.isCreate === 0 ? "确定" : "更新"))]
              ),
              _vm._v(" "),
              _c("el-button", { on: { click: _vm.close } }, [_vm._v("取消")]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }